import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-miterlimit": "10",
  d: "M8.84 2.4 3.367 8.194c-.207.22-.407.653-.447.953l-.247 2.16c-.086.78.474 1.313 1.247 1.18l2.147-.367c.3-.053.72-.273.926-.5l5.474-5.793c.946-1 1.373-2.14-.1-3.533C10.9.914 9.787 1.4 8.84 2.4Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-miterlimit": "10",
  d: "M7.926 3.367A4.084 4.084 0 0 0 11.56 6.8M2 14.666h12"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }